import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './MaxIntelIncreasePulseEffect.css';

/**
 * Three glowing blue upward chevrons on the general portrait (max intel increase).
 * Mirrors Hive Surge (62) grow chevrons but targets player/opponent HUD avatar.
 */
export function MaxIntelIncreasePulseEffect({ generalZone, animationKey }) {
  const [center, setCenter] = useState(null);

  useLayoutEffect(() => {
    let cancelled = false;
    const measure = (attempt) => {
      if (!generalZone) {
        if (!cancelled) setCenter(null);
        return;
      }
      const el = document.querySelector(`[data-zone="${generalZone}"]`);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) {
          if (!cancelled) {
            setCenter({
              x: rect.left + rect.width / 2,
              y: rect.top + rect.height / 2,
            });
          }
          return;
        }
      }
      if (attempt < 18 && !cancelled) {
        requestAnimationFrame(() => {
          if (!cancelled) measure(attempt + 1);
        });
      }
    };
    setCenter(null);
    measure(0);
    return () => {
      cancelled = true;
    };
  }, [generalZone, animationKey]);

  if (!center) {
    return null;
  }

  const layer = (
    <div
      className="max-intel-increase-pulse-root"
      aria-hidden
      data-animation-key={animationKey}
      style={{
        left: `${center.x}px`,
        top: `${center.y}px`,
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className="max-intel-increase-pulse-stack">
        <span className="max-intel-increase-pulse-chevron" />
        <span className="max-intel-increase-pulse-chevron" />
        <span className="max-intel-increase-pulse-chevron" />
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(layer, document.body);
  }
  return layer;
}

export default MaxIntelIncreasePulseEffect;
